import sortBy from 'lodash/sortBy';

export type SectionOverviewMinimumData = {
  id: string;
  sort: string;
  subSectionsOverview:
    | {
        id: string;
      }[]
    | null;
};

export function getSortedSectionIds<T extends SectionOverviewMinimumData>(
  sectionsData: T[] | undefined
) {
  return sortBy(sectionsData, 'sort').map(section => section.id);
}
